export const stringifyBool = (b: boolean) => {
    if (b) {
        return 'Yes'
    }

    return 'No'
}
